export default __webpack_public_path__ + "static/media/happyMom.e5fa20b5.svg";